export default {
  computed: {
    isStaging() {
      return import.meta.env.VITE_ENV === "staging";
    },
    // UI上で環境を区別するために、ステージング環境の場合、配色を変更する
    // ステージング環境なら青系
    // それ以外ならピンク系
    themeClasses() {
      return {
        text: this.isStaging ? "text-blue" : "text-pink",
        color: this.isStaging ? "blue" : "pink"
      };
    }
  }
};
